import { Storage } from "@capacitor/storage";
import { loadModeHorsligne } from "./HorsLigne/loadmodeHL";
const apiUrl = process.env.REACT_APP_API_URL;


export const sendAllData = async (
    selectedPresta: any,
    pvId: any,
    devId: any,
    conf: any,
    showError: any,
    showModal: any,
    setDetails: any
) => {
    const casseUrl = "/posts/modifligne-prestacasse";
    const consoUrl = "/posts/modifligne-prestaconso";
    const hourUrl = "/posts/modifligne-prestahours";
    const informationSignUrl = "/posts/validPrestation";

    const normalize = (val: any) => {
        if (val === null || val === undefined) return null;
        if (typeof val === "string" && val.trim() !== "") {
            const num = Number(val);
            return isNaN(num) ? val : num;
        }
        if (typeof val === "number") return val;
        return val;
    };

    const pv_id = normalize(pvId);
    const dev_id = normalize(devId);

    try {
        const sendDataSend = async (dataSend: any[]) => {
            let allSuccessful = true;
            for (const item of dataSend) {
                let url = null;
                if (item.e_qte_casse !== undefined) {
                    url = casseUrl;
                } else if (item.e_qte_consommee_uco !== undefined) {
                    url = consoUrl;
                } else if (item.v_heure_prevue_depart_site !== undefined) {
                    url = hourUrl;
                }
                if (url) {
                    const response = await fetch(`${apiUrl}${url}`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${conf.token}`,
                        },
                        body: JSON.stringify(item),
                    });
                    if (!response.ok) {
                        console.error(
                            `Erreur lors de l'envoi de l'élément ${item.id} :`,
                            response.statusText
                        );
                        if ([403, 500].includes(response.status)) {
                            allSuccessful = false;
                        }
                    }
                }
            }
            return allSuccessful;
        };

        const sendInformationSign = async (
            infoSign: any,
            e_pv_id: number | null,
            e_dev_id: number | null,
            e_dp_id: number | null,
            namePresta: string
        ) => {
            if (infoSign) {
                const enrichedInfoSign = {
                    ...infoSign,
                    e_pv_id,
                    e_dev_id,
                    e_dp_id,
                };
                const response = await fetch(`${apiUrl}${informationSignUrl}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${conf.token}`,
                    },
                    body: JSON.stringify(enrichedInfoSign),
                });

                if (!response.ok) {
                    console.error(
                        `Erreur lors de l'envoi de \`informationSign\` :`,
                        response.statusText
                    );
                    const error = await response.json();
                    showError(`${error?.message}`);
                } else {
                    loadModeHorsligne("prestaHl", conf).then((data: any[]) => {
                        if (!data) return;

                        const updatedPrestations = data.map((presta: any) => {
                            const targetId = e_pv_id ?? e_dev_id ?? e_dp_id;
                            const matchesEntete =
                                targetId &&
                                [presta.entete.pv_id, presta.entete.dev_id, presta.entete.dp_id]
                                    .some(id => String(id) === String(targetId));


                            if (!matchesEntete) return presta;
                            // Ajouter isSent dans chaque objet result
                            const updatedResult = presta.result?.map((res: any) => ({
                                ...res,
                                isSent: true,
                            })) || [];
                            const updatedEntete = {
                                ...presta.entete,
                                isSent: true
                            };
                            setDetails(updatedResult)
                            return {
                                ...presta,
                                entete: updatedEntete,
                                result: updatedResult
                            };
                        });
                        Storage.set({
                            key: `prestaHl_${conf.user.user_code}`,
                            value: JSON.stringify(updatedPrestations),
                        });
                        showModal(`La prestation ${namePresta} a été envoyée avec succès.`);
                    });

                }
            }
        };

        // Boucle principale
        for (const presta of selectedPresta) {
            try {
                // On ignore les "E" et on ne prend que les phases "P"
                if (presta.rpl_type === "E" && Array.isArray(presta.sous_categorie)) {
                    const phases = presta.sous_categorie.filter(
                        (phase: any) => phase.rpl_type === "P"
                    );

                    // Vérifier que toutes les phases sont signées
                    const allPhasesSigned = phases.every(
                        (phase: any) =>
                            phase.isValid ||
                            (phase.informationSign?.e_signature_client &&
                                phase.informationSign?.e_signature_responsable)
                    );

                    // Envoyer chaque phase dans l'ordre
                    const sortedPhases = phases.sort(
                        (a: any, b: any) => a.rpl_ordre - b.rpl_ordre
                    );

                    for (const [index, phase] of sortedPhases.entries()) {
                        let allSuccessful = true;

                        // 1. Envoyer les items de la phase
                        if (Array.isArray(phase.dataSend)) {
                            const success = await sendDataSend(phase.dataSend);
                            if (!success) allSuccessful = false;
                        }

                        // 2. Envoyer la signature de la phase
                        if (allSuccessful) {
                            await sendInformationSign(
                                phase.informationSign,
                                pv_id,
                                dev_id,
                                phase.dp_id,
                                phase.rpl_designation
                            );
                        }
                    }

                } if (presta.rpl_type !== "E" || presta.rpl_type !== "P") {
                    let allSuccessful = true;

                    const isSigned =
                        presta.isValid ||
                        (presta.informationSign?.e_signature_client &&
                            presta.informationSign?.e_signature_responsable);


                    if (Array.isArray(presta.dataSend)) {
                        const success = await sendDataSend(presta.dataSend);
                        if (!success) allSuccessful = false;
                    }

                    if (allSuccessful) {
                        await sendInformationSign(
                            presta.informationSign,
                            pv_id,
                            dev_id,
                            presta.dp_id = null,
                            presta.rpl_designation
                        );
                    }
                }
            } catch (error) {
                showError(
                    `Impossible d'envoyer la prestation : ${presta.rpl_designation}`
                );
            }
        }
    } catch (error) {
        console.error("Erreur lors de l'envoi des données :", error);
    }
};

const isSigned = (infoSign: any, isValid?: boolean) => {
    if (isValid) return true;
    return infoSign?.e_signature_client && infoSign?.e_signature_responsable;
};
